import { ReactElement } from 'react'
import DriverOrdersList from '../../components/Driver/orders'
import Layout from '../../components/layout'

const DriverOrdersPage = (): ReactElement => {
  return (
    <Layout>
      <DriverOrdersList />
    </Layout>
  )
}

export default DriverOrdersPage;
